import { GivelifyModal, GivelifyLabel } from '@givelify/givelify-ui';
import { styled } from '@mui/material/styles';

export const StyledModal = styled(GivelifyModal)({
    textAlign: 'center',
});

export const ContentWrapper = styled('div')({
    paddingLeft: 32,
    paddingRight: 32,
});

export const StyledText = styled(GivelifyLabel)({
    marginTop: 24,
    marginBottom: 32,
});

export const StyledLink = styled('a')(({ theme }) => ({
    textDecoration: 'none',
    color: theme.legacy.colors?.primary || theme.legacy.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
    '&:active': {
        color:
            theme.legacy.colors?.accentDarkBlue ||
            theme.legacy.palette.primary.dark,
        textDecoration: 'underline',
    },
}));
